import React from "react";
import logo from "../images/preferenceslogo.png"

export default function SuccessfulSignup({ message = "Thank you for signing up with Chestertons!", description = ""}) {
    return (
      <div>
        <img src={logo} className="mb-5" alt="Logo" />
        <h1 className="text-4xl mb-4 text-chestertons-purple">{message}</h1>
        <p className="text-sm">
          {description}
        </p>
      </div>
    );
  }
  